var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_https_bn_sme_dev_platform_swagger_ui_xnmgkmonsa_as_a_run_app_remoteEntry_js_97465183__;